// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-checker {
    background: white;
    border-radius: 8px;
    padding: 24px;
    border: 1px solid var(--border-color);
    font-family: var(--app-font-family);
    max-width: 800px;
    margin: 24px auto;
}

.wallet-checker-header {
    text-align: center;
    margin-bottom: 24px;
}

.wallet-checker-header h2 {
    color: var(--primary-color);
    font-family: var(--logo-font-family);
    margin: 0 0 8px 0;
}

.wallet-checker-header p {
    color: #666;
    margin: 0;
}

.wallet-checker-input-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.wallet-input {
    width: 100%;
    padding: 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-family: var(--app-font-family);
    font-size: 14px;
    resize: vertical;
}

.error-message {
    color: #dc2626;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.check-button,
.clear-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 24px;
    background: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: var(--app-font-family);
    font-weight: 500;
    transition: opacity 0.2s;
}

.check-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.clear-button {
    background: #f3f4f6;
    color: var(--primary-color);
    margin-top: 16px;
}

.results-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.success-banner {
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
    color: #166534;
}

.success-message h3 {
    margin: 0 0 4px 0;
    font-size: 18px;
}

.success-message p {
    margin: 0;
    font-size: 14px;
}

.results-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border-radius: 4px;
    background: #f8f9fa;
    border: 1px solid #e5e7eb;
}

.wallet-address {
    font-family: monospace;
    font-size: 14px;
    color: #374151;
}

.eligible-amount {
    color: #059669;
    font-weight: 500;
}

.not-eligible-text {
    color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/styles/stHype/staking/wallet_checker.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".wallet-checker {\n    background: white;\n    border-radius: 8px;\n    padding: 24px;\n    border: 1px solid var(--border-color);\n    font-family: var(--app-font-family);\n    max-width: 800px;\n    margin: 24px auto;\n}\n\n.wallet-checker-header {\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.wallet-checker-header h2 {\n    color: var(--primary-color);\n    font-family: var(--logo-font-family);\n    margin: 0 0 8px 0;\n}\n\n.wallet-checker-header p {\n    color: #666;\n    margin: 0;\n}\n\n.wallet-checker-input-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.wallet-input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    font-family: var(--app-font-family);\n    font-size: 14px;\n    resize: vertical;\n}\n\n.error-message {\n    color: #dc2626;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n}\n\n.check-button,\n.clear-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 24px;\n    background: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: var(--app-font-family);\n    font-weight: 500;\n    transition: opacity 0.2s;\n}\n\n.check-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.clear-button {\n    background: #f3f4f6;\n    color: var(--primary-color);\n    margin-top: 16px;\n}\n\n.results-section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.success-banner {\n    background: #f0fdf4;\n    border: 1px solid #86efac;\n    border-radius: 8px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    color: #166534;\n}\n\n.success-message h3 {\n    margin: 0 0 4px 0;\n    font-size: 18px;\n}\n\n.success-message p {\n    margin: 0;\n    font-size: 14px;\n}\n\n.results-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.result-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    border-radius: 4px;\n    background: #f8f9fa;\n    border: 1px solid #e5e7eb;\n}\n\n.wallet-address {\n    font-family: monospace;\n    font-size: 14px;\n    color: #374151;\n}\n\n.eligible-amount {\n    color: #059669;\n    font-weight: 500;\n}\n\n.not-eligible-text {\n    color: #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
